import gql from 'graphql-tag';

export default gql`
mutation AddEndpointImage(
        $uuid: String!,
        $name: String!,
        $desc: String!,
        $tag1: String!,
        $tag2: String!,
        $tag3: String!,
        $tag4: String!,
        $tag5: String!
        ) {
    addImage(input:{
        uuidEndpoint: $uuid,
        name: $name,
        desc: $desc,
        tag1: $tag1,
        tag2: $tag2,
        tag3: $tag3,
        tag4: $tag4,
        tag5: $tag5
    }) {
        __typename
        uuid
        images
        signedUrl
    }
}
`;
